<template>
  <v-card>
    <v-form @submit.prevent="true" v-model="mocType.formValid" autocomplete="off">
      <v-container style="padding-top: 0px; padding-bottom: 0px">
        <v-row>
          <v-col cols="6">
            <v-autocomplete
              required
              label="Change Category"
              item-value="clientID"
              item-title="name"
              variant="underlined"
              v-model="mocType.changeCategories"
              :items="changeCategoriesList"
              :error-messages="changeCategoryErrors"
              :readonly="readonly ? true : !mocType.isNew"
              :disabled="!mocType.isNew"
              :return-object="true"
              chips
              closable-chips
              multiple
              v-if="mocType.isNew"
            >
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggle" class="ml-2">
                  <div class="d-flex align-center">
                  <v-list-item-action>
                    <v-icon :color="mocType.changeCategories.length > 0 ? 'grey-lighten-2' : ''">{{ icon }}</v-icon>
                  </v-list-item-action>

                  <v-list-item-title class="ml-2">Select All</v-list-item-title>
                 </div>
                </v-list-item>
              
                <v-divider class="mt-2"></v-divider>
              </template>
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0"
                  ><span>{{ item.name }}</span></v-chip
                >
                <span v-if="index === 1" class="grey--text text-caption"
                  ><strong>(+{{ mocType.changeCategories.length - 1 }} others)</strong></span
                >
              </template>
            </v-autocomplete>

            <v-autocomplete
              required
              label="Change Category"
              variant="underlined"
              item-value="clientID"
              item-title="name"
              v-model="mocType.changeCategory.clientID"
              :items="changeCategoriesList"
              readonly
              disabled
              v-else
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              required
              label="MOC Type"
              variant="underlined"
              item-title="value"
              item-value="clientID"
              v-model="mocType.id"
              :items="filteredList"
              :error-messages="mocTypeErrors"
              :readonly="readonly ? true : !mocType.isNew"
              :disabled="!mocType.isNew"
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="2">
            <v-text-field :readonly="readonly" variant="underlined" type="number" label="Display Order" v-model="mocType.displayOrder"></v-text-field>
          </v-col>
        </v-row>
        <v-row style="padding-bottom: 10px">
          <v-col cols="12" sm="6">
            <people-picker-ms
              @update="(args) => this.handleUpdateApprovers(args)"
              v-model="mocType.approvers"
              title="Approvers"
              :readonly="readonly"
              show-required
              bulkUserAdd
            ></people-picker-ms>
          </v-col>
          <v-col cols="12" sm="6">
            <people-picker-ms
              :readonly="readonly"
              @update="(args) => this.handleUpdateFYIs(args)"
              v-model="mocType.fyis"
              title="FYI"
              bulkUserAdd
            ></people-picker-ms>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <TaskPicker
              :tasks="tasks"
              @selectTask="selectTask"
              @deleteTask="deleteSelectedTask"
              :selectedTasks="mocType.tasks"
              @onClick="onTaskClick"
              @addTask="onTaskAdd"
              :readonly="readonly"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row justify="end">
            <v-btn
              :disabled="
                mocType.isNew
                  ? !(mocType.changeCategories || []).length || !mocType.id
                  : !mocType.changeCategory.clientID || !mocType.id
              "
              color="success"
              @click="save"
              v-if="!readonly"
              >Save</v-btn
            >
            <v-btn @click="close">Close</v-btn>
            <v-btn v-if="readonly ? false : mocType.isNew" color="error" variant="flat" @click="deleteMocType">Delete</v-btn>
          </v-row>
        </v-card-actions>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import PeoplePickerMs from '@/components/peoplePicker/PeoplePickerMs'
import TaskPicker from '@/components/TaskPicker'

export default {
  name: 'mocType',
  data: () => ({
    expanded: false,
    minimumNameLength: 0,
    maximumNameLength: 120,
    minimumTranslationLength: 0,
    maximumTranslationLength: 300,
    tempApprovers: [],
    tempFyis: [],
    selectedAll: false
  }),
  methods: {
    deleteMocType: function () {
      this.$emit('deleteMOCType', this.mocType)
    },
    handleUpdateApprovers: function (usersAction) {
      this.mocType.approvers = usersAction.Users
    },
    handleUpdateFYIs: function (usersAction) {
      this.mocType.fyis = usersAction.Users
    },
    close: function () {
      this.$emit('close')
    },
    save: function () {
      this.$emit('saveMocType', this.mocType)
    },
    addApprovers: function (approvers) {
      if (approvers) {
        if (this.tempApprovers == null) {
          this.tempApprovers = []
        }
        this.tempApprovers = this.tempApprovers.concat(approvers)
        this.mocType.approvers = this.tempApprovers
      }
    },
    addFyis: function (fyis) {
      if (fyis) {
        if (this.tempFyis == null) {
          this.tempFyis = []
        }
        this.tempFyis = this.tempFyis.concat(fyis)
        this.mocType.fyis = this.tempFyis
      }
    },
    selectTask(task) {
      if (!task) return
      this.mocType.tasks = (this.mocType.tasks || []).filter((t) => t !== task.clientID).concat(task.clientID)
    },
    deleteSelectedTask(task) {
      this.mocType.tasks = this.mocType.tasks.filter((t) => t !== task.clientID)
    },
    onTaskClick(task) {
      this.$emit('onTaskClick', task)
    },
    onTaskAdd(search) {
      this.$emit('onTaskAdd', search, this.selectTask)
    },
    toggle() {
      if (this.areAllChangeCategoriesSelected) {
        this.mocType.changeCategories = []
      } else {
        this.mocType.changeCategories = this.ChangeCategories.slice()
      }
    }
  },
  computed: {
    mocTypeErrors() {
      return !this.mocType.id ? 'MOC Type is required' : null
    },
    changeCategoryErrors() {
      return (this.mocType.changeCategories || []).length === 0 ? 'Change Category is required' : null
    },
    filteredList() {
      let filteredMocTypes = []
      if (this.mocType.isNew) {
        const changeCategoriesIds = this.mocType.changeCategories.map((changeCategory) => changeCategory.clientID)
        const changeCategories = this.ChangeCategories.filter((c) => changeCategoriesIds.includes(c.clientID))
        const changeCategoriesMocTypeIds = changeCategories
          .reduce((acc, cur) => {
            acc = acc.concat(cur.mocTypes)
            return acc
          }, [])
          .map((m) => m.id)
        filteredMocTypes = changeCategoriesMocTypeIds.filter((x) => x !== this.mocType.id)
      }
      return this.mocTypeList.filter((m) => !filteredMocTypes.includes(m.clientID))
    },
    changeCategoriesList() {
      return this.ChangeCategories.map((changeCategory) => {
        return {
          ...changeCategory,
          name: `${changeCategory.name}${changeCategory.enabled ? '' : '(Disabled)'}`
        }
      })
    },
    areAllChangeCategoriesSelected() {
      return this.mocType.changeCategories.length === this.ChangeCategories.length
    },
    areSomeChangeCategoriesSelected() {
      return this.mocType.changeCategories.length > 0 && !this.areAllChangeCategoriesSelected
    },
    icon() {
      if (this.areAllChangeCategoriesSelected) return 'mdi-checkbox-outline'
      if (this.areSomeChangeCategoriesSelected) return 'mdi-minus-box-outline'
      return 'mdi-checkbox-blank-outline'
    }
  },
  props: {
    mocType: Object,
    mocTypeList: Array,
    ChangeCategories: Array,
    tasks: Array,
    readonly: Boolean
  },
  components: {
    PeoplePickerMs,
    TaskPicker
  },
  mounted() {
    this.addApprovers(this.mocType.approvers)
    this.addFyis(this.mocType.fyis)
  }
}
</script>

<style scoped>
.task {
  border: 1px solid #ccc;
}
</style>
